<template>
  <div class="signin">
    <img src="@/assets/logo_all_blue.png" class="logo" />

    <div class="inputs">
      <transition name="fade">
        <el-alert
          v-if="error"
          :title="error"
          class="error-alert"
          type="error"
          @close="error = null">
        </el-alert>
      </transition>
    
      <dg-input type="text" v-model="username" placeholder="E-mail" icon="user"/>

      <div class="password-wrapper">
        <dg-input type="password" v-model="password" placeholder="Password" icon="lock" @keyup.enter.native="handleSignin"/>
        <router-link to="forgot" tag="button" class="el-button el-button--text forgot-button">Forgot?</router-link>
      </div>

      <el-button :loading="loading" type="primary" @click="handleSignin" class="signin-button" style="margin-bottom: 15px;">Signin</el-button>
      <router-link to="signup" tag="button" class="el-button el-button--text signup-button">Not yet registered? Sign up now!</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'signin',
  data () {
    return {
      username: '',
      password: '',
      loading: false,
      remember: false,
      redirect: null,
      error: null
    }
  },
  methods: {
    handleSignin () {
      this.signIn()
        .catch(error => {
          this.error = error.response.data['']
          this.loading = false
        })
    },
    async signIn () {
      this.loading = true

      const data = { 
        email: this.username, 
        password: this.password,
        remember: this.remember 
      }

      const response = await this.$http.post(this.$api.auth.signIn, data)
      this.$auth.setToken(response.data.token)
      this.$root.getUserOrganizations()
      this.$router.push((this.redirect && this.redirect.length > 0) ? this.redirect : '/dashboard/')
    }
  },
  created () {
    if (this.$auth.isLoggedIn()) {
      this.$router.push((this.redirect && this.redirect.length > 0) ? this.redirect : '/dashboard/')
    }
  },
  mounted () {
    this.redirect = this.$route.query.redirect
  }
}
</script>

<style lang="scss" scoped>

  .signin {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    @include breakpoint (xs) {
      max-height: 100vh;
    }
  }

  .password-wrapper {
    position: relative;

    .forgot-button {
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 0px;
    }
  }

  .logo {
    width: 160px;
    height: auto;
    display: block;
    margin: 0 auto;
    margin-bottom: 30px;
  }

  .input-password {
    position: relative;

    .forgot {
      cursor: pointer;
      position: absolute;
      top: 0px;
      line-height: 50px;
      font-size: 12px;
      right: 10px;
    }
  }

  .inputs {
    width: 300px;
    margin: 0 auto;
    margin-top: 50px;

    .dg-input {
      margin-bottom: 20px;
    }

    button {
      margin-top: 20px;
    }
  }


  .signin-button, .signup-button {
    width: 100%;
    display: block;
  }

  .signup-button {
    font-size: 14px !important;
    margin-left: 0px;
  }

  .or {
    text-align: center;
  }

  .error-alert {
    margin-bottom: 20px;
  }

  .language-change-container {
    width: 65px;
    bottom: 15px;
    left: 15px;
    position: fixed;
  }

</style>



// WEBPACK FOOTER //
// src/components/front/Signin.vue